module.exports = "/_next/static/images/4d331e1b416b9de49d17cb519d801d57-phone-with-app-open-and-card@2x-md.jpg";